import React, { useState } from 'react';

export default function GBPTest() {
  const [accounts, setAccounts] = useState([]);
  const [accountInput, setAccountInput] = useState('');
  const [locations, setLocations] = useState([]);
  const [log, setLog] = useState('');
  const [loading, setLoading] = useState(false);

  const getBrandId = () => {
    try {
      return localStorage.getItem('currentBrandId') || sessionStorage.getItem('currentBrandId') || '';
    } catch { return ''; }
  };

  const listAccounts = async () => {
    try {
      setLoading(true);
      setLog('');
      const brandId = getBrandId();
      const res = await fetch('https://api.glowytics.com/api/auth/gbp/accounts', {
        credentials: 'include',
        headers: { 'X-Brand-ID': brandId }
      });
      const txt = await res.text();
      setLog(txt);
      if (!res.ok) { setAccounts([]); return; }
      const data = JSON.parse(txt);
      setAccounts(Array.isArray(data?.accounts) ? data.accounts : []);
    } catch (e) {
      setLog(String(e?.message || e));
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  };

  const listLocations = async () => {
    try {
      setLoading(true);
      setLog('');
      const brandId = getBrandId();
      const url = new URL('https://api.glowytics.com/api/auth/gbp/locations');
      if (accountInput) url.searchParams.set('account', accountInput);
      const res = await fetch(url.toString(), {
        credentials: 'include',
        headers: { 'X-Brand-ID': brandId }
      });
      const txt = await res.text();
      setLog(txt);
      if (!res.ok) { setLocations([]); return; }
      const data = JSON.parse(txt);
      setLocations(Array.isArray(data?.locations) ? data.locations : []);
    } catch (e) {
      setLog(String(e?.message || e));
      setLocations([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 space-y-4">
      <div className="text-xl font-semibold">Google Business Profile – Test Lab</div>
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <button
            onClick={listAccounts}
            className="px-3 py-2 rounded-lg bg-black text-white disabled:opacity-50"
            disabled={loading}
          >
            List Accounts
          </button>
          <input
            value={accountInput}
            onChange={(e) => setAccountInput(e.target.value)}
            placeholder="accounts/12345678901234567890"
            className="px-3 py-2 border rounded-lg w-[360px]"
          />
          <button
            onClick={listLocations}
            className="px-3 py-2 rounded-lg bg-blue-600 text-white disabled:opacity-50"
            disabled={loading}
          >
            List Locations
          </button>
        </div>
        <div className="text-xs text-gray-500">
          Not: Account alanını boş bırakırsanız ilk hesabın lokasyonlarını çeker.
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="border rounded-xl p-3">
          <div className="font-medium mb-2">Accounts</div>
          <div className="space-y-2">
            {accounts.map((a, i) => (
              <div key={i} className="p-2 rounded-lg border">
                <div className="text-sm font-medium">{a.accountName || a.name}</div>
                <div className="text-xs text-gray-500">{a.name}</div>
              </div>
            ))}
            {accounts.length === 0 && <div className="text-sm text-gray-500">No accounts</div>}
          </div>
        </div>
        <div className="border rounded-xl p-3">
          <div className="font-medium mb-2">Locations</div>
          <div className="space-y-2">
            {locations.map((l, i) => (
              <div key={i} className="p-2 rounded-lg border">
                <div className="text-sm font-medium">{l.title || l.name}</div>
                <div className="text-xs text-gray-500">{l.name}</div>
                {l.websiteUri ? <div className="text-xs"><a className="text-blue-600" href={l.websiteUri} target="_blank" rel="noreferrer">{l.websiteUri}</a></div> : null}
                {l.address?.postalCode ? (
                  <div className="text-xs text-gray-600">{l.address?.postalCode} {l.address?.locality} {l.address?.administrativeArea}</div>
                ) : null}
              </div>
            ))}
            {locations.length === 0 && <div className="text-sm text-gray-500">No locations</div>}
          </div>
        </div>
      </div>

      <div className="border rounded-xl p-3">
        <div className="font-medium mb-2">Raw Response</div>
        <pre className="text-xs whitespace-pre-wrap break-all">{log}</pre>
      </div>
    </div>
  );
}


